import config from 'SRC/config/config.json'

export const imagesCDN = config.mediaCDN
